import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

const LoadingScreen = () => {
  const { t } = useTranslation('common')
  return (
    <div className="min-h-screen bg-dark-950 flex items-center justify-center">
      <div className="text-center">
        {/* Glass morphism loading container */}
        <div className="glass-card p-12 inline-block">
          {/* Animated logo/spinner */}
          <motion.div
            className="w-16 h-16 mx-auto mb-6 relative"
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          >
            <div className="w-16 h-16 border-4 border-transparent border-t-primary-500 border-r-primary-500 rounded-full"></div>
          </motion.div>

          {/* Loading text */}
          <motion.h2
            className="text-xl font-semibold text-dark-100 mb-2"
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          >
            {t('general.k_320eb3')}
          </motion.h2>
          
          <p className="text-sm text-dark-400">
            {t('general.k_9eb41e')}
          </p>
        </div>

        {/* Floating particles animation */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(20)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute w-1 h-1 bg-primary-500/30 rounded-full"
              initial={{
                x: Math.random() * window.innerWidth,
                y: window.innerHeight + 10,
              }}
              animate={{
                y: -10,
                opacity: [0, 1, 0],
              }}
              transition={{
                duration: Math.random() * 3 + 2,
                repeat: Infinity,
                delay: Math.random() * 2,
              }}
              style={{
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default LoadingScreen